export default __webpack_public_path__ + "static/media/sponsorship.8d63b431.svg";